const closeButtonLabel = "Chiudi";
const itCH = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  itCH as default
};
